import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ProgressCircleIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, className } = {
    ...defaultIconProps,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      style={{ fontSize }}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
    >
      <circle
        cx="32"
        cy="32"
        r="30"
        transform="rotate(90 32 32)"
        stroke="url(#angularGradient)"
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="angularGradient"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(90)"
        >
          <stop offset="0%" stopColor="rgba(217, 227, 232, 0)" />
          <stop offset="70%" stopColor="rgba(217, 227, 232, 0.4)" />
          <stop offset="100%" stopColor="rgba(217, 227, 232, 1)" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ProgressCircleIcon;
